import { z } from 'zod';
import { spouseSchema } from './spouse.js';
export const personalInfoSchema = z.object({
    first_name: z.string().meta({ label: 'First Name' }),
    last_name: z.string().meta({ label: 'Last Name' }),
    birth_date: z.iso.date().meta({ field: 'date', label: 'Birth Date' }).optional(),
    spouse: spouseSchema.optional(),
});
